import React from 'react';
// Import images (real ART-WER photos)
import ctaTwoBg from '../../../assets/images/artwer/project-1-balkon-hilversum-card.jpg';
import ctaTwoImg from '../../../assets/images/artwer/project-3-galerij-amsterdam.jpg';
import ctaTwoImgWebp from '../../../assets/images/artwer/project-3-galerij-amsterdam.webp';
import ctaLogo from '../../../assets/images/artwer/logo-white-text.png';

const CtaTwo = () => {
  return (
    <section className="cta-two">
      <div className="container">
        <div className="cta-two__inner">
          <div
            className="cta-two__bg"
            style={{ backgroundImage: `url(${ctaTwoBg})` }}
          ></div>
          <div className="cta-two__img-and-content">
            <div className="cta-two__img">
              <picture>
                <source srcSet={ctaTwoImgWebp} type="image/webp" />
                <img src={ctaTwoImg} alt="Opgeleverde galerijvloer in Amsterdam" width="1467" height="1100" loading="lazy" />
              </picture>
            </div>
            <div className="cta-two__content">
              <img src={ctaLogo} className="artwer-cta-logo" alt="ART-WER" />
              <h2 className="cta-two__title">Tijd voor de volgende stap</h2>
              <p className="cta-two__text">
                Bel of mail vandaag nog voor een vrijblijvende opname op locatie. U spreekt direct
                de vakman — geen wachtlijst, geen tussenpersoon.
              </p>
              <div className="cta-two__btn-box">
                <a href="#contact" className="cta-two__btn thm-btn-two">
                  Plan een opname<span className="icon-dubble-arrow-right"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaTwo;
